import { render } from "./TelaPagamento.vue?vue&type=template&id=30fd4a5b&scoped=true"
import script from "./TelaPagamento.vue?vue&type=script&lang=js"
export * from "./TelaPagamento.vue?vue&type=script&lang=js"

import "./TelaPagamento.vue?vue&type=style&index=0&id=30fd4a5b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fd4a5b"]])

export default __exports__